













































import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component
export default class App extends Vue {
  data() {
    return {
      assets: {
        photos: {
          "cliffs of moher doolin": {
            category: "ireland",
            alt: "Cliffs of Moher Near Doolin",
            thumb:
              "https://live.staticflickr.com/65535/50420956272_9d3d3498e3_c_d.jpg",
            fullrez:
              "https://live.staticflickr.com/65535/50420956272_50099c2b34_k_d.jpg",
            ratio: "s3by2"
          },
          "carrauntoohil blizzard": {
            category: "ireland",
            alt: "Carrauntoohil Blizzard",
            thumb:
              "https://live.staticflickr.com/65535/50420955937_6cbf3928b3_c_d.jpg",
            fullrez:
              "https://live.staticflickr.com/65535/50420955937_5f655833ad_k_d.jpg",
            ratio: "s1by1"
          },
          "adeline charles fort": {
            category: "ireland",
            alt: "Adeline at Charles Fort",
            thumb:
              "https://live.staticflickr.com/65535/50420956072_91303a0e26_c_d.jpg",
            fullrez:
              "https://live.staticflickr.com/65535/50420956072_016de2a0cf_k_d.jpg",
            ratio: "s3by2"
          },
          "cliffs of moher ocean": {
            category: "ireland",
            alt: "Cliffs of Moher Ocean View",
            thumb:
              "https://live.staticflickr.com/65535/50420956312_e9544beb9a_c_d.jpg",
            fullrez:
              "https://live.staticflickr.com/65535/50420956312_1a4e316d8e_k_d.jpg",
            ratio: "s3by2"
          },
          "alec the photographer": {
            category: "other",
            alt: "Alec the Photographer",
            thumb:
              "https://live.staticflickr.com/65535/50420787566_186d409448_c_d.jpg",
            fullrez:
              "https://live.staticflickr.com/65535/50420787566_49953c136a_k_d.jpg",
            ratio: "s4by5"
          },
          "cliffs of moher waterfall": {
            category: "ireland",
            alt: "Cliffs of Moher Waterfall",
            thumb:
              "https://live.staticflickr.com/65535/50420788061_e55aebfa03_c_d.jpg",
            fullrez:
              "https://live.staticflickr.com/65535/50420788061_07ec8ac752_k_d.jpg",
            ratio: "s3by2"
          },
          "torc waterfall mushrooms": {
            category: "ireland",
            alt: "Torc Waterfall Mushrooms",
            thumb:
              "https://live.staticflickr.com/65535/50420095568_c4f488f5d4_c_d.jpg",
            fullrez:
              "https://live.staticflickr.com/65535/50420095568_3d8bb9ee3a_k_d.jpg",
            ratio: "s3by4"
          },
          "hiroshima castle": {
            category: "japan",
            alt: "Hiroshima Castle",
            thumb:
              "https://live.staticflickr.com/65535/50420095628_f55bee90a0_c_d.jpg",
            fullrez:
              "https://live.staticflickr.com/65535/50420095628_154637713c_k_d.jpg",
            ratio: "s3by2"
          },
          "kamakura street flowers": {
            category: "japan",
            alt: "Kamakura Street Flowers",
            thumb:
              "https://live.staticflickr.com/65535/50420788226_298286c7f6_c_d.jpg",
            fullrez:
              "https://live.staticflickr.com/65535/50420788226_5b1988428d_k_d.jpg",
            ratio: "s3by2"
          },
          "fushimi inari": {
            category: "japan",
            alt: "Fushimi Inari",
            thumb:
              "https://live.staticflickr.com/65535/50420095703_6a86d883bd_c_d.jpg",
            fullrez:
              "https://live.staticflickr.com/65535/50420095703_f5d7fd300e_k_d.jpg",
            ratio: "s3by2"
          },
          "kyoto sunset": {
            category: "japan",
            alt: "Kyoto Kodai Ji Zen Temple",
            thumb:
              "https://live.staticflickr.com/65535/50420095713_5419d886df_c_d.jpg",
            fullrez:
              "https://live.staticflickr.com/65535/50420095713_ec5cbc1c23_k_d.jpg",
            ratio: "s3by2"
          },
          "kyoto imperial palace": {
            category: "japan",
            alt: "Kyoto Imperial Palace",
            thumb:
              "https://live.staticflickr.com/65535/50420956632_a0b3cb7a62_c_d.jpg",
            fullrez:
              "https://live.staticflickr.com/65535/50420956632_510f89cb36_k_d.jpg",
            ratio: "s3by2"
          },
          "nara parade": {
            category: "japan",
            alt: "Nara Parade",
            thumb:
              "https://live.staticflickr.com/65535/50420956667_c7238bc987_c_d.jpg",
            fullrez:
              "https://live.staticflickr.com/65535/50420956667_891137e730_k_d.jpg",
            ratio: "s3by4"
          },
          "tokyo skytree": {
            category: "japan",
            alt: "View from Tokyo Skytree at Night",
            thumb:
              "https://live.staticflickr.com/65535/50420788561_abfaac296e_c_d.jpg",
            fullrez:
              "https://live.staticflickr.com/65535/50420788561_c71163e3fe_k_d.jpg",
            ratio: "s3by4"
          },
          "jigokudani stare": {
            category: "japan",
            alt: "Macaque Monkey Staring from Hot Spring",
            thumb:
              "https://live.staticflickr.com/65535/50420096113_a20360a533_c_d.jpg",
            fullrez:
              "https://live.staticflickr.com/65535/50420096113_f1264a7d0d_k_d.jpg",
            ratio: "s3by2"
          },
          "jigokudani rest": {
            category: "japan",
            alt: "Macaque Monkeys Resting",
            thumb:
              "https://live.staticflickr.com/65535/50420096183_39d0c13d65_c_d.jpg",
            fullrez:
              "https://live.staticflickr.com/65535/50420096183_e9ab5f57f4_k_d.jpg",
            ratio: "s3by2"
          },
          "jigokudani face": {
            category: "japan",
            alt: "Resting Macaque Face",
            thumb:
              "https://live.staticflickr.com/65535/50420788751_62b3c0205e_c_d.jpg",
            fullrez:
              "https://live.staticflickr.com/65535/50420788751_b3e278413e_k_d.jpg",
            ratio: "s3by2"
          },
          rose: {
            category: "other",
            alt: "A Birthday Rose",
            thumb:
              "https://live.staticflickr.com/65535/50420957102_3b7878979d_c_d.jpg",
            fullrez:
              "https://live.staticflickr.com/65535/50420957102_6cca7f4f31_k_d.jpg",
            ratio: "s3by4"
          },
          "smokey christmas": {
            category: "other",
            alt: "Smokey Sleeping Beneath the Christmas Tree",
            thumb:
              "https://live.staticflickr.com/65535/50420096323_205684d80e_c_d.jpg",
            fullrez:
              "https://live.staticflickr.com/65535/50420096323_b380a5259e_k_d.jpg",
            ratio: "s3by2"
          },
          suzlon: {
            category: "other",
            alt: "Suzlon Wind Turbine",
            thumb:
              "https://live.staticflickr.com/65535/50420874742_83656c959c_c_d.jpg",
            fullrez:
              "https://live.staticflickr.com/65535/50420874742_9350cda1e7_k_d.jpg",
            ratio: "s3by4"
          }
        }
      }
    };
  }
}
